import React from "react";
import PropTypes from "prop-types";
import { VIDEO_TYPE } from "./VideoType";
import { YouTubeVideo } from "./YouTubeVideo";

const VideoPlayer = ({ type, ...props }) => {
	switch (type.toLowerCase()) {
		case VIDEO_TYPE.YOUTUBE.toLowerCase():
			return (
				<YouTubeVideo
					className={props.className}
					style={props.style}
					videoId={props.videoId}
					videoTitle={props.videoTitle}
					autoPlay={props.autoPlay}
					lang={props.lang}
					setVideoPlayer={props.setVideoPlayer}
				/>
			);
		case "custom":
			return props.customImplementation?.(props);
		default:
			return null;
	}
};

VideoPlayer.propTypes = {
	type: PropTypes.string,
	className: PropTypes.string,
	style: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
	videoId: PropTypes.string.isRequired,
	videoTitle: PropTypes.string,
	autoPlay: PropTypes.bool,
	lang: PropTypes.string,
	setVideoPlayer: PropTypes.func,
	customImplementation: PropTypes.func,
};

VideoPlayer.defaultProps = {
	type: VIDEO_TYPE.YOUTUBE,
	className: undefined,
	style: undefined,
	videoTitle: undefined,
	autoPlay: false,
	lang: "en",
	setVideoPlayer: () => {},
	customImplementation: () => {},
};

export default VideoPlayer;
export { VideoPlayer, VIDEO_TYPE };
